export default __webpack_public_path__ + "static/media/image2.c48e5f8f.svg";